import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('resultMessage', [ 'resultMessage' ])
  },
  watch: {
  },
  methods: {
    checkRoleName (rule, value, cb) {
      this.debouncer.debounce(500, function () {
        let cond = []
        cond.push({ 'field name': 'label', operator: '=', value: [ value ] })
        this.$tango.searchUserRole({ conditions: cond}).then(rep => {
          if (rep.resultCode === 0) {
            if (rep.totalCount === 0) cb()
            else {
              rep.roleList.filter(r => {
                if (r.roleId !== this.form.roleId) {
                  rule.message = 'Role name already exists'
                  cb(new Error())
                }
              })
              cb()
            }
          }
          else {
            rule.message = 'Role name already exists'
            cb(new Error())
          }
        })
      }.bind(this))
    },
    handleDelete: function (cond) {
      this.$confirm('This will permanently delete the role. Continue ?', 'Warning', {
        confirmButtonText: this.$t('OK'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(() => {
        this.$tango.deleteUserRole({ roleList: cond }).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error(this.$t('Deleted failed') + ' ' + this.$t(this.resultMessage[rep.resultCode]))
          }
          else {
            this.$message({
              type: 'success',
              message: this.$t('Deleted successfully')
            })
            this.resetPermission()
            for(let item in cond) {
              let route = {
                path: '/admin/role/edit',
                params: { recordId: item.roleId },
                meta: { title: this.$route.meta.title }
              }
              this.$store.dispatch('tagsView/delView', route)
            }
            this.$router.push({ path: '/next' }).then(() => { return this.$router.push({ name: 'adminRoleList' }) }).catch(() => {})
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
          this.$message({
            type: 'error',
            message: err.message
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.spinner.show()
          this.form.permissionList.functionList = this.buildPermissionList()
          this.form.permissionList.brokerList = this.buildBrokerList()
          this.isReadOnly = true
          let api = this.$route.params.create ? 'createUserRole' : 'updateUserRole'
          this.$tango[api](this.form).then(r => {
            this.$refs.spinner.hide()
            if (r.resultCode !== 0) throw new Error(r.resultCode)
            if (this.userInfos.roleId === r.roleId) {
              // this.$store.dispatch('user/setPermission', r.permissionList.brokerList)
              this.$acl.setPermissions(r.userInfos.permissions)
              this.$acl.setPermissionBrokers(r.userInfos.permissionBrokers)
              this.$store.dispatch('permission/GenerateRoutes', { roles: r.userInfos.permissions, isAdmin: this.isAdmin })
            }
            this.$message({
              type: 'success',
              message: this.$route.params.create ? this.$t('Creation role has been successfully completed') : this.$t('Modification role has been successfully completed')
            })

            this.$route.params.recordLabel = r.label
            this.$route.params.recordId = this.form.roleId = r.roleId
            if (this.$route.params.create) {
              this.$route.params.create = false
              this.$route.params.recordLabel = r.label
              this.$store.dispatch('tagsView/addView', this.$route)
            }
            else {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            this.resetPermission()
            this.reload()
          }).catch(err => {
            this.$refs.spinner.hide()
            this.$message({
              type: 'error',
              message: this.resultMessage[err]
            })
          })
        }
      })
    }
  }
}
